import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useField } from 'formik';
import clsx from 'clsx';
import ReactTags from 'react-tag-autocomplete';
import { FormErrorMsg } from '../form-error-msg';

export interface TagItem {
  id: string | number;
  name: string | number;
  disabled?: boolean;
}

interface IInputTags {
  name: string;

  placeholderText?: string;

  removeButtonText?: string;

  newTagText?: string;

  className?: string;

  suggestions?: TagItem[];

  /* Default 2 */
  minQueryLength?: number;

  /* Default 6 */
  maxSuggestionsLength?: number;

  fieldType?: 'email' | 'text';
}

export function InputTags({
  name,
  placeholderText = 'Thêm giá trị',
  removeButtonText = 'Xóa giá trị',
  newTagText = 'Thêm giá trị:',
  className = '',
  minQueryLength = 2,
  maxSuggestionsLength = 6,
  suggestions,
  fieldType = 'email',
}: IInputTags) {
  const [tags, setTags] = useState<TagItem[]>([]);
  const [field, , helper] = useField<TagItem[]>(name);
  const [curSuggestions, setCurSuggestions] = useState<TagItem[]>([]);
  const reactTags = useRef();

  useEffect(() => {
    const initialValue = field.value || [];

    setTags(initialValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    suggestions && setCurSuggestions(suggestions);
  }, [suggestions]);

  const onDelete = useCallback(
    (tagIndex) => {
      const newTags = tags.filter((_, i) => i !== tagIndex);

      helper.setValue(newTags);
      setTags(newTags);
    },
    [tags, helper]
  );

  const onAddition = useCallback(
    (newTag: TagItem) => {
      if (
        tags.some((tag: TagItem) => {
          return tag.name === newTag.name;
        })
      ) {
        return;
      }

      const newTags = [...tags, newTag];

      helper.setValue(newTags);
      setTags(newTags);
    },
    [tags, helper]
  );

  if (JSON.stringify(tags) !== JSON.stringify(field.value)) {
    const newTags = field.value || [];

    setTags(newTags);
  }

  const handleValidate = (newTag) => {
    if (fieldType === 'email') {
      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(newTag.name);
    }
  };

  const handleBlur = () => {
    reactTags.current &&
      (reactTags.current as any).setState({
        ...(reactTags.current as any).state,
        query: '',
      });
  };

  return (
    <>
      <ReactTags
        allowNew
        newTagText={newTagText}
        ref={reactTags}
        className={clsx('form-control', className)}
        tags={tags}
        suggestions={curSuggestions}
        placeholderText={placeholderText}
        removeButtonText={removeButtonText}
        minQueryLength={minQueryLength}
        maxSuggestionsLength={maxSuggestionsLength}
        onValidate={handleValidate}
        onDelete={onDelete}
        onAddition={onAddition}
        onBlur={handleBlur}
      />
      <FormErrorMsg name={name} />
    </>
  );
}
